import { PAGES_TRIPS_UPDATE } from "../actions";

export const pagesTripsUpdate = trips => ({
  type: PAGES_TRIPS_UPDATE,
  payload: { trips }
});
